import { ContainerPriceMapper } from "./container-price.mapper";
import { ContainerPriceDict } from "./container-price-dict.type";
import { ContainerPrice } from "./container-price.model";

export class ContainerPriceDictMapper {
  public static toDict(data: any = []): ContainerPriceDict {
    const containers = <ContainerPriceDict>{};

    if (Array.isArray(data)) {
      data.forEach((containerObject) => {
        containers[containerObject.name] =
          ContainerPriceMapper.map(containerObject);
      });
    }

    return containers;
  }

  public static toArray(data: ContainerPriceDict): ContainerPrice[] {
    return Object.keys(data).map(
      (containerName) =>
        new ContainerPrice(containerName, data[containerName].value),
    );
  }
}
